import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface Template {
  _id: string;
  schema_name: string;
}

export interface TemplateDropdownResponse {
  success: boolean;
  code: number;
  data: Template[];
}

export interface ProcessFilesRequest {
  ai_performance_level: string;
  file_ids: string[];
  schema_id: string;
}

export interface ProcessFilesResponse {
  success: boolean;
  code: number;
  message?: string;
  data?: any;
}

class DocumentParsingService {
  // GET: Get templates dropdown list
  async getTemplatesDropdown(): Promise<TemplateDropdownResponse> {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TEMPLATES.DROPDOWN);
      return response.data;
    } catch (error) {
      console.error('Error fetching templates dropdown:', error);
      throw error;
    }
  }

  // POST: Process files for parsing
  async processFiles(
    documentStoreId: string,
    data: ProcessFilesRequest
  ): Promise<ProcessFilesResponse> {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.DOCUMENT_PARSING.PROCESS_FILES(documentStoreId),
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error processing files:', error);
      throw error;
    }
  }
}

export const documentParsingService = new DocumentParsingService();
export default documentParsingService;
